
<div *ngIf="{ validDate: validDate$ | async, onCreateSession: onCreateSession$ | async, created: created$ | async } as data" class="container">
	<div class="row">
		<loading *ngIf="data.validDate === null || data.onCreateSession"></loading>

		<div *ngIf="!data.onCreateSession && data.validDate !== null && !data.created" class="container alert__container">
			<ngb-alert [dismissible]="false">
				<p><strong>Atención</strong></p>
				<p>No se ha podido generar una sesión en Comunità con su usuario, esto puede ser debido a alguno de los siguientes motivos:</p>
				<ul>
					<li>Su usuario no se encuentra correctamente configurado en el sistema</li>
					<li>Algún problema técnico está impidiendo iniciar el sitio</li>
					<li *ngIf="!data.validDate">Existe una diferencia de fecha u horario entre su computadora y el servidor</li>
				</ul>
				<div class="continuar__container">
					<button class="continuar" (click)="onContinuar()">Continuar</button>
				</div>
			</ngb-alert>
		</div>
	</div>
</div>
